"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_use_1 = require("react-use");
const classnames_1 = __importDefault(require("classnames"));
const compose_1 = __importDefault(require("utils/compose"));
const uuid_1 = require("uuid");
const immutable_1 = require("immutable");
const core_1 = require("companion-app-components/utils/core");
const auth_1 = require("companion-app-components/flux/auth");
const categories_1 = require("companion-app-components/flux/categories");
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
const transaction_list_1 = require("companion-app-components/flux/transaction-list");
const mui_1 = require("tss-react/mui");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const StdForm_1 = __importDefault(require("data/StdForm"));
const StdFormDialog_1 = __importDefault(require("components/Dialogs/StdFormDialog"));
const QButton_1 = __importDefault(require("components/QButton"));
const ScheduleTransactionSelector_1 = __importStar(require("components/Dialogs/WfBillScout/ScheduleTransactionSelector"));
const styles_1 = require("components/Dialogs/WfBillScout/styles");
const selectors_1 = require("data/transactions/selectors");
const TransactionSelectList_1 = __importDefault(require("components/TransactionSelectList"));
const SearchBox_1 = __importDefault(require("components/SearchBox"));
const ScheduledTransactionFormContainer_1 = __importDefault(require("components/ScheduledTransactions/ScheduledTransactionFormContainer"));
const selectors_2 = require("data/institutionLogins/selectors");
const typeStdForm = 'WEBFIRST_BILL_SCOUT_WIZARD';
const INITIAL_STEP = ScheduleTransactionSelector_1.BILLS_STEP;
const UI_SCHEDULE_TRANSACTION_SELECTOR = 'SCHEDULE_TRANSACTION_SELECTOR';
const UI_TRANSACTION_SELECTOR = 'TRANSACTION_SELECTOR';
const INITIAL_CURRENT_UI = UI_SCHEDULE_TRANSACTION_SELECTOR;
const INITIAL_SELECTED_ITEMS = (0, immutable_1.Map)({
    [ScheduleTransactionSelector_1.INCOME_STEP]: (0, immutable_1.List)([]),
    [ScheduleTransactionSelector_1.BILLS_STEP]: (0, immutable_1.List)([]),
    [ScheduleTransactionSelector_1.ALL_STEP]: (0, immutable_1.List)([]),
});
const titles = {
    [`${UI_SCHEDULE_TRANSACTION_SELECTOR}_${ScheduleTransactionSelector_1.BILLS_STEP}`]: {
        headline: 'Let\'s start with your bills',
        caption: `Review these recurring payments we found in your transactions.
    Only select your recurring payments.`,
    },
    [`${UI_SCHEDULE_TRANSACTION_SELECTOR}_${ScheduleTransactionSelector_1.BILLS_STEP}_review`]: {
        headline: 'Review your bills',
        caption: 'Review your bills. You can update or remove any if required',
    },
    [`${UI_TRANSACTION_SELECTOR}_${ScheduleTransactionSelector_1.BILLS_STEP}`]: {
        headline: 'Find bills from your transactions',
        caption: 'Only choose transactions that represent recurring bills, subscriptions or transfers.',
    },
    [`${UI_TRANSACTION_SELECTOR}_${ScheduleTransactionSelector_1.ALL_STEP}`]: {
        headline: 'Find bills/income from your transactions',
        caption: 'Only choose transactions that represent recurring bills, income, subscriptions or transfers.',
    },
    [`${UI_SCHEDULE_TRANSACTION_SELECTOR}_${ScheduleTransactionSelector_1.INCOME_STEP}`]: {
        headline: 'Now add your income',
        caption: `Review these recurring income we found in your transactions.
    Select & add all that are your income.`,
    },
    [`${UI_SCHEDULE_TRANSACTION_SELECTOR}_${ScheduleTransactionSelector_1.INCOME_STEP}_review`]: {
        headline: 'Review your income',
        caption: 'Review your income. You can update or remove any if required',
    },
    [`${UI_TRANSACTION_SELECTOR}_${ScheduleTransactionSelector_1.INCOME_STEP}`]: {
        headline: 'Find income from your transactions',
        caption: 'Only choose items that represent recurring income payments (not one-time payments).',
    },
};
const trackingEvents = {
    [`${ScheduleTransactionSelector_1.BILLS_STEP}-confirmed`]: core_1.tracker.events.confirmedBill,
    [`${ScheduleTransactionSelector_1.BILLS_STEP}-addedNew`]: core_1.tracker.events.addedNewBill,
    [`${ScheduleTransactionSelector_1.BILLS_STEP}-removed`]: core_1.tracker.events.removedBill,
    [`${ScheduleTransactionSelector_1.BILLS_STEP}-edited`]: core_1.tracker.events.editedBill,
    [`${ScheduleTransactionSelector_1.BILLS_STEP}-skip`]: core_1.tracker.events.skipBill,
    [`${ScheduleTransactionSelector_1.INCOME_STEP}-confirmed`]: core_1.tracker.events.confirmedIncome,
    [`${ScheduleTransactionSelector_1.INCOME_STEP}-addedNew`]: core_1.tracker.events.addedNewIncome,
    [`${ScheduleTransactionSelector_1.INCOME_STEP}-removed`]: core_1.tracker.events.removedIncome,
    [`${ScheduleTransactionSelector_1.INCOME_STEP}-edited`]: core_1.tracker.events.editedIncome,
    [`${ScheduleTransactionSelector_1.INCOME_STEP}-skip`]: core_1.tracker.events.skipIncome,
};
const useStyles = (0, mui_1.makeStyles)()(styles_1.WFBillScoutStyles);
const WfBillScout = ({ dialogId, initialStep, singleStep, billsIncomeFlow, hideAddManually, addManualST, }) => {
    const { classes } = useStyles();
    const scheduledTransactions = (0, react_redux_1.useSelector)(scheduled_transactions_1.scheduledTransactionsSelectors.getScheduledTransactionsSortedByPayee);
    const allUpcomingTxns = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getAllUpcomingTransactions)(state, scheduledTransactions));
    const institutionsRefreshing = (0, react_redux_1.useSelector)(selectors_2.getIdsRefreshing);
    const isWebFirstDataset = (0, react_redux_1.useSelector)(auth_1.authSelectors.getIsWebfirstDataset);
    const dispatch = (0, react_redux_1.useDispatch)();
    const getCategories = () => dispatch(categories_1.categoriesActions.getCategories());
    const dispatchUpdateScheduledTransactionAction = (data) => dispatch(scheduled_transactions_1.scheduledTransactionsActions.updateScheduledTransaction(data));
    const dispatchDeleteScheduledTransactionAction = (data) => dispatch(scheduled_transactions_1.scheduledTransactionsActions.deleteScheduledTransaction(data, { undo: { userMessage: 'Schedule Transaction deleted.' } }));
    const dispatchCreateBillScoutScheduleAction = (data) => dispatch(scheduled_transactions_1.scheduledTransactionsActions.createBillScoutSchedule(data));
    const [currentUI, setcurrentUI] = (0, react_1.useState)(isWebFirstDataset ? INITIAL_CURRENT_UI : UI_TRANSACTION_SELECTOR);
    const [step, setStep] = (0, react_1.useState)(billsIncomeFlow && !isWebFirstDataset ? initialStep : INITIAL_STEP);
    const [reviewCurrentStep, setReviewCurrentStep] = (0, react_1.useState)(false);
    const [selectedScheduleTxns, setSelectedScheduleTxns] = (0, react_1.useState)(INITIAL_SELECTED_ITEMS);
    const [selectedTxns, setSelectedTxns] = (0, react_1.useState)(INITIAL_SELECTED_ITEMS);
    const [search, setSearch] = (0, react_1.useState)(undefined);
    const [editScheduledTransaction, setEditScheduledTransaction] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        const getScheduledTransactions = () => dispatch(scheduled_transactions_1.scheduledTransactionsActions.getScheduledTransactions());
        if (institutionsRefreshing.isEmpty()) {
            getScheduledTransactions();
        }
    }, [institutionsRefreshing, dispatch]);
    (0, react_use_1.useEffectOnce)(() => {
        getCategories();
    });
    const setSelectedScheduleTxnsItems = (thisStep, list) => {
        setSelectedScheduleTxns(selectedScheduleTxns.set(thisStep, list));
    };
    const setSelectedTxnsItems = (thisStep, list) => {
        setSelectedTxns(selectedTxns.set(thisStep, list));
    };
    const openTransactionSelector = () => {
        core_1.tracker.track(core_1.tracker.events.findFromTransaction);
        setcurrentUI(UI_TRANSACTION_SELECTOR);
    };
    const closeTransactionSelector = (handleClose) => (event) => {
        // Check if it's a web first dataset to handle transactions selector, CMP-7267.
        if (isWebFirstDataset) {
            setcurrentUI(UI_SCHEDULE_TRANSACTION_SELECTOR);
        }
        else {
            handleClose(event, 'SKIP_BUTTON');
        }
    };
    const createEmptyScheduleTransaction = (handleClose) => {
        const clientId = (0, uuid_1.v4)().toUpperCase();
        core_1.tracker.track(core_1.tracker.events.addManually);
        closeTransactionSelector(handleClose);
        setEditScheduledTransaction(scheduled_transactions_1.scheduledTransactionsTypes.mkScheduledTransaction({
            clientId,
            type: step,
        }));
    };
    const handleAddManually = ({ handleClose }) => (event) => {
        core_1.tracker.track(core_1.tracker.events.addManually);
        if (addManualST) {
            handleClose(event, 'SKIP_BUTTON');
            addManualST();
        }
        else {
            createEmptyScheduleTransaction(handleClose);
        }
    };
    const showNextStep = () => {
        if (step === ScheduleTransactionSelector_1.BILLS_STEP) {
            setStep(ScheduleTransactionSelector_1.INCOME_STEP);
            setReviewCurrentStep(false);
        }
    };
    const getSchTxnsOfStep = () => scheduledTransactions === null || scheduledTransactions === void 0 ? void 0 : scheduledTransactions.filter((x) => x.type === step);
    const filterTxnsByType = ({ amount }) => {
        if (step === ScheduleTransactionSelector_1.ALL_STEP) {
            return true;
        }
        return step === ScheduleTransactionSelector_1.INCOME_STEP ? amount > 0 : amount < 0;
    };
    const resetSearch = () => setSearch(undefined);
    const getBaseId = (id = '') => `WFBillScout-${currentUI}-${step}${id !== '' ? `-${id}` : ''}`;
    const getSelectedTxns = () => selectedTxns.get(step);
    const getSelectedSchTxns = () => selectedScheduleTxns.get(step);
    const submitScheduleTransactionForm = ({ id, isUserVerified }) => {
        if (id) {
            core_1.tracker.track(trackingEvents[`${step}-edited`], { number: 1 });
        }
        else {
            core_1.tracker.track(trackingEvents[`${step}-addedNew`], { number: 1 });
        }
        if (!isUserVerified) {
            const selectedItems = getSelectedSchTxns();
            if (selectedItems) {
                const isSelected = selectedItems.findIndex((x) => x === id) >= 0;
                if (!isSelected) {
                    setSelectedScheduleTxnsItems(step, selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.push(id));
                }
            }
        }
    };
    const createAndDeleteSchTxns = (closeAction) => (event) => {
        const selectedSchTxns = selectedScheduleTxns.get(step);
        const schTxnOfStep = getSchTxnsOfStep();
        const schTxnToVerify = schTxnOfStep === null || schTxnOfStep === void 0 ? void 0 : schTxnOfStep.filter((schTxn) => !schTxn.isUserVerified && (selectedSchTxns === null || selectedSchTxns === void 0 ? void 0 : selectedSchTxns.contains(schTxn.id)));
        // Verify Schedule Transactions
        if (schTxnToVerify && schTxnToVerify.size > 0) {
            schTxnToVerify.forEach((schTxn) => {
                dispatchUpdateScheduledTransactionAction(schTxn.merge({
                    isUserVerified: true,
                }));
            });
            core_1.tracker.track(trackingEvents[`${step}-confirmed`], { number: schTxnToVerify.size });
        }
        // Clean search for next step
        resetSearch();
        // Clean selectedScheduleTxnsItems
        setSelectedScheduleTxnsItems(step, INITIAL_SELECTED_ITEMS.get(step));
        // Show review page before show next step
        if (!reviewCurrentStep) {
            setReviewCurrentStep(true);
            return;
        }
        // Show next step or close modal
        if (step === ScheduleTransactionSelector_1.BILLS_STEP) {
            showNextStep();
        }
        else if (closeAction) {
            closeAction(event);
        }
    };
    const deleteScheduleTransaction = (schTxn) => {
        core_1.tracker.track(trackingEvents[`${step}-removed`], { number: 1 });
        dispatchDeleteScheduledTransactionAction(schTxn.merge({
            isDeleted: true,
        }));
    };
    const onSkip = (closeAction) => (event) => {
        core_1.tracker.track(trackingEvents[`${step}-skip`]);
        if (!reviewCurrentStep) {
            setReviewCurrentStep(true);
            return;
        }
        // Show next step or close modal
        if (step === ScheduleTransactionSelector_1.BILLS_STEP) {
            showNextStep();
        }
        else if (closeAction) {
            closeAction(event);
        }
    };
    const onGoBack = () => setReviewCurrentStep(false);
    const createBillScout = (handleClose) => {
        const selectedTransactions = getSelectedTxns();
        selectedTransactions === null || selectedTransactions === void 0 ? void 0 : selectedTransactions.forEach((txnID) => {
            if (txnID) {
                const clientId = (0, uuid_1.v4)().toUpperCase();
                dispatchCreateBillScoutScheduleAction({ clientId, id: txnID });
            }
        });
        // Clean selectedTxns
        setSelectedTxnsItems(step, INITIAL_SELECTED_ITEMS.get(step));
        closeTransactionSelector(handleClose);
        setReviewCurrentStep(true);
    };
    const checkTxnIsSelected = (id) => {
        const selectedItems = getSelectedTxns();
        if (selectedItems) {
            return selectedItems.findIndex((x) => x === id) >= 0;
        }
        return false;
    };
    const selectTxn = (event) => {
        const { id } = JSON.parse(event.currentTarget.id);
        const isSelected = checkTxnIsSelected(id);
        let selectedTransactions = getSelectedTxns();
        if (isSelected) {
            selectedTransactions = selectedTransactions === null || selectedTransactions === void 0 ? void 0 : selectedTransactions.filterNot((x) => x === id);
        }
        else {
            selectedTransactions = selectedTransactions === null || selectedTransactions === void 0 ? void 0 : selectedTransactions.push(id);
        }
        setSelectedTxnsItems(step, selectedTransactions);
    };
    const renderTitle = () => {
        const titleKey = currentUI !== UI_TRANSACTION_SELECTOR ?
            `${currentUI}_${step}${reviewCurrentStep ? '_review' : ''}` : `${currentUI}_${step}`;
        const titleData = titles[titleKey] || {};
        if (billsIncomeFlow && currentUI === UI_SCHEDULE_TRANSACTION_SELECTOR && !reviewCurrentStep) {
            titleData.headline = step === ScheduleTransactionSelector_1.INCOME_STEP ? 'Select your income' : 'Select the bills you pay';
        }
        return (<div>
        <div className={classes.headlineTitle}>{titleData.headline}</div>
        <div id={getBaseId('headline')} className={classes.headlineCaption}>{titleData.caption}</div>
      </div>);
    };
    const renderActions = ({ handleClose }) => {
        var _a;
        const selectedTransactions = getSelectedTxns();
        const selectedSchTransactions = getSelectedSchTxns();
        const stepSchTransactions = (_a = getSchTxnsOfStep()) === null || _a === void 0 ? void 0 : _a.filter((x) => x.isUserVerified);
        const stepLabel = step === ScheduleTransactionSelector_1.BILLS_STEP ? 'bills' : 'income';
        return (<div className={classes.actions}>
        {currentUI === UI_SCHEDULE_TRANSACTION_SELECTOR && singleStep && reviewCurrentStep &&
                <QButton_1.default className={classes.wideButton} variant="contained" onClick={(event) => handleClose(event, 'SKIP_BUTTON')} id={getBaseId('action-done-button')}>
            Done
          </QButton_1.default>}
        {currentUI === UI_SCHEDULE_TRANSACTION_SELECTOR && singleStep && !reviewCurrentStep &&
                <QButton_1.default className={classes.wideButton} variant="contained" onClick={() => setReviewCurrentStep(true)} id={getBaseId('action-review-button')}>
            Review
          </QButton_1.default>}
        {currentUI === UI_SCHEDULE_TRANSACTION_SELECTOR && !singleStep && (<>
            <div className={classes.helperLine}>
              {reviewCurrentStep ?
                    `${stepSchTransactions === null || stepSchTransactions === void 0 ? void 0 : stepSchTransactions.size} ${stepLabel} added` :
                    `${selectedSchTransactions === null || selectedSchTransactions === void 0 ? void 0 : selectedSchTransactions.size} ${stepLabel} selected`}
            </div>
            {!reviewCurrentStep && (<QButton_1.default className={classes.wideButton} classes={{ textButton: classes.skipButton }} onClick={onSkip((event) => handleClose(event, 'SKIP_BUTTON'))} id={getBaseId('action-skip-button')}>
                Skip suggestions
              </QButton_1.default>)}
            <QButton_1.default className={classes.wideButton} classes={{ disableOther: classes.continueButton }} variant="contained" onClick={createAndDeleteSchTxns((event) => handleClose(event, 'COMPLETE_FLOW'))} id={getBaseId('action-continue-button')} disabled={!reviewCurrentStep && (selectedSchTransactions === null || selectedSchTransactions === void 0 ? void 0 : selectedSchTransactions.size) === 0}>
              {!reviewCurrentStep && 'Add to list'}
              {reviewCurrentStep && step === ScheduleTransactionSelector_1.BILLS_STEP && 'Continue to Income'}
              {reviewCurrentStep && step === ScheduleTransactionSelector_1.INCOME_STEP && 'Finish'}
            </QButton_1.default>
          </>)}
        {currentUI === UI_TRANSACTION_SELECTOR && (<>
            <Typography_1.default variant="body2" className={classes.manualLine}>
              {"Couldn't Find?"}
              <QButton_1.default className={classes.manualButton} id="add-manually-transaction" onClick={handleAddManually({ handleClose })}>
                ADD MANUALLY
              </QButton_1.default>
            </Typography_1.default>
            <QButton_1.default className={(0, classnames_1.default)(classes.wideButton, classes.backButton)} onClick={closeTransactionSelector(handleClose)} id={getBaseId('action-back-button')}>
              Cancel
            </QButton_1.default>
            <QButton_1.default className={classes.wideButton} classes={{ disableOther: classes.continueButton }} disabled={(selectedTransactions === null || selectedTransactions === void 0 ? void 0 : selectedTransactions.size) === 0} onClick={() => createBillScout(handleClose)} id={getBaseId('action-add-to-list-button')} variant="contained">
              Add to List
            </QButton_1.default>
          </>)}
      </div>);
    };
    return (<StdFormDialog_1.default className={classes.dialog} dialogProps={{
            disableBackdropClick: true,
            disableEscapeKeyDown: true,
            fullWidth: true,
            maxWidth: 'lg',
            classes: { paperWidthMd: classes.dialog },
        }} showCloseButton={currentUI === UI_SCHEDULE_TRANSACTION_SELECTOR} title={renderTitle()} renderActions={renderActions} dialogId={dialogId}>
      <>
        {currentUI === UI_SCHEDULE_TRANSACTION_SELECTOR && (<Grid_1.default container className={classes.body}>
            <ScheduleTransactionSelector_1.default scheduledTransactions={getSchTxnsOfStep()} allUpcomingTxns={allUpcomingTxns} selected={getSelectedSchTxns()} setSelectedItems={setSelectedScheduleTxnsItems} setEditScheduledTransaction={setEditScheduledTransaction} deleteScheduleTransaction={deleteScheduleTransaction} openTransactionSelector={openTransactionSelector} createEmptyScheduleTransaction={createEmptyScheduleTransaction} showFindingRecurring={!institutionsRefreshing.isEmpty()} type={step} reviewCurrentStep={reviewCurrentStep} baseId={getBaseId} hideAddManually={hideAddManually} onGoBack={onGoBack}/>
          </Grid_1.default>)}

        {currentUI === UI_TRANSACTION_SELECTOR && (<Grid_1.default container className={(0, classnames_1.default)(classes.body, classes.bodyTxnSelector)}>
            <div id={getBaseId('search')} className={classes.searchBarRoot}>
              <SearchBox_1.default onSearch={setSearch} autoSearch={false} autoFocus collapsable={false} initialValue={search} placeholder="Search Transactions" showUnderline classes={{
                root: classes.searchBar,
                input: classes.searchInput,
                searchIcon: classes.searchIcon,
                cancelIcon: classes.cancelIcon,
            }}/>
            </div>
            <TransactionSelectList_1.default clickFunc={selectTxn} highlight={getSelectedTxns()} filterByType={filterTxnsByType} filter={search} onReset={resetSearch} multiSelect hideCategory transactionListSelector={transaction_list_1.transactionListSelectors.getLesserBilledTransactions}/>
          </Grid_1.default>)}
        {editScheduledTransaction &&
            <ScheduledTransactionFormContainer_1.default key={editScheduledTransaction ? (editScheduledTransaction.id || editScheduledTransaction.clientId) : 'noKey'} scheduledTransaction={editScheduledTransaction && editScheduledTransaction.toJS()} onClose={() => { setEditScheduledTransaction(null); }} onSubmit={submitScheduleTransactionForm} deleteUserVerificationFromPayload hideDeleteIcon/>}
      </>
    </StdFormDialog_1.default>);
};
exports.default = (0, compose_1.default)((0, StdForm_1.default)({ type: typeStdForm }))(WfBillScout);
